import { mainStore } from 'partners-widget-core';

export const MOBILE = 'mobile';
export const DESKTOP = 'desktop';

const getType = () => localStorage.getItem(mainStore.store.env.isMobileKey);

export const checkMobile = () => getType() === MOBILE;

export const checkDesktop = () => getType() === DESKTOP;
